<div id="landing_aceptacion-credito" class="container">
  <div class="wrapped-card rounded-lg">
    <div class="row g-0">
      <div
        class="col-12 col-lg-6 d-flex flex-column justify-content-center align-content-center order-2 order-xl-1 p-3">
        <h2 class="text-uppercase text-center title">
          ¡Tu solicitud de crédito ha sido creada con éxito y se le ha asignado el número <strong>{{ idSolicitud }}</strong>!
        </h2>
        <p class="subtitle mt-3 mt-lg-5 text-center">
          {{mensajeBienvenida}}
        </p>
        <div class="row justify-content-md-center mt-lg-3">
          <div class="col-12">
            <a id="btnSolicitudFinalizar" routerLink="/microempresario/home" class="btn btn-primary hvr-shrink w-100">
              Finalizar
            </a>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 order-1 order-xl-2">
        <img src="assets/img/solicitudCredito.jpg" alt="Secure" class="img-fluid">
      </div>
    </div>
  </div>
</div>
